export const StaffTrainingStatus = ({ status }) =>
  status === 'in_progress' ? (
    <div className="staff-languages">
      <div className="detail-badge">T1</div>
    </div>
  ) : null
